<template>
  <div class="floorSetting">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['商城管理', $route.meta.title]"
    >
      <template slot="controls">
        <el-link
          @click="explain = true"
          style="margin-right: 10px"
          icon="el-icon-question"
          :underline="false"
          type="warning"
          >操作说明</el-link
        >
      </template>
    </crumbs-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 90px)"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column
        align="center"
        prop="index"
        show-overflow-tooltip
        label="序号"
      >
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="TypeName"
        align="center"
        show-overflow-tooltip
        label="名称"
      >
      </el-table-column>
      <el-table-column
        prop="ImgType"
        label="别名"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="sort"
        label="排序"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag type="warning" v-if="scope.row.status == '1'">已禁用</el-tag>
          <el-tag type="success" v-if="scope.row.status == '2'">已启用</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="redact(scope.row)"
            >编辑</el-button
          >
          <el-button
            v-if="scope.row.status == '1'"
            type="success"
            style="padding: 2px 3px"
            plain
            @click="changeStatus(scope, '2')"
            >启用</el-button
          >
          <el-button
            v-else-if="scope.row.status == '2'"
            type="warning"
            style="padding: 2px 3px"
            plain
            @click="changeStatus(scope, '1')"
            >禁用</el-button
          >
          <el-button
            v-if="showAddGoods.indexOf(scope.row.ImgType) > -1"
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="handleGoods(scope)"
            >添加商品</el-button
          >
          <el-button
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="handleImg(scope)"
            >添加图片</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
    <!-- 修改楼层名 -->
    <el-dialog
      title="修改楼层名"
      :visible.sync="dialogVisible"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="500px"
    >
      <el-form
        :model="formData"
        label-position="left"
        label-width="80px"
        :rules="formRule"
        ref="addForm"
      >
        <el-form-item label="楼层名称" prop="name">
          <el-input
            v-model="formData.name"
            placeholder="请输入楼层名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number
            v-model="formData.sort"
            :controls="false"
            style="width: 100%"
            :min="1"
            placeholder="请输入排列序号"
          >
          </el-input-number>
        </el-form-item>
        <el-form-item label="专区图片" prop="imgurl">
          <upload
            @fileChange="uploadSortImg"
            accept="image/jpg,image/jpeg,image/png"
            :multiple="true"
          ></upload>
            <img-view
              style="margin-left: 20px"
              :imgList="[{ url: sortImg, id: 0 }]"
            ></img-view>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureModify">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="操作说明"
      :visible.sync="explain"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="70%"
    >
      <div class="explain-text">
        <p>该界面维护商品PC、App楼层显示内容</p>
        <p>使用说明：可控制启用/禁用、楼层名称修改</p>
        <p>添加商品(显示该按钮的楼层可设置)：维护该楼层下要显示的商品</p>
        <p>
          专区推荐楼层：在PC、App商城首页显示4张自定义图片，在商品管理->推荐专区中进行维护，启用该选项可显示该楼层
        </p>
        <p>首页显示和广告图片楼层未启用</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "floorSetting",
  data() {
    return {
      entId: "",
      tableData: [
        {
          index: "1",
          name: "专区推荐",
          alias: "Prefecture",
          sort: 1,
        },
      ],
      /**dialog */
      dialogVisible: false,
      formData: {
        name: "",
        sort: 1,
        id: "",
        txtImgUrl: "",
        linkurl: "",
        UrlType: "",
        AndroidLinkUrl: "",
      },
      formRule: {
        name: [{ required: true, message: "请输入楼层名称", trigger: "blur" }],
        sort: [{ required: true, message: "请输入楼层顺序", trigger: "blur" }],
      },
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      sortImg: "", // 分类图片，用于本地显示

      /**显示批量添加图片按钮的条件 */
      showAddGoods: ["Family", "InSeason", "Product", "Weekly", "Health"], //这几种商品需要添加，其他的不需要

      /**使用说明 */
      explain: false,
    };
  },

  mounted() {
    this.entId = window.localStorage.getItem("entId");
    this.getTableData();
  },
  methods: {
    /**获取表格数据 */
    getTableData() {
      let data = {
        type: "PC_GetImgType",
        status: 0,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      var proc = "Pc_Log"; //存储过程名
      var type = "ReturnList";
      ///加载页面数据
      this.$requestSys({
        method: "post",
        url:
          "configuration/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          if (res.flag == 0) {
            // this.tableData = res.data;  "Family", "InSeason", "Product", "Weekly", "Health"
            this.tableData = [];
            res.data.forEach((i) => {
              if (i.ImgType == "Recommend" || i.ImgType == "Advertising" || i.ImgType == "Family" || i.ImgType == "InSeason" || i.ImgType == "Product" || i.ImgType == "Weekly" || i.ImgType == "Health"  || i.ImgType == "Prefecture" || i.ImgType == 'Brand') {
                console.log(i, 1);
              } else {
                this.tableData.push(i);
              }
            });
            console.log(this.tableData);
            this.allPage = this.tableData.length;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.PageIndex = 1;
      this.getTableData();
    },
    redact(row) {
      this.dialogVisible = true;
      this.formData.name = row.TypeName;
      this.formData.sort = row.sort;
      this.formData.id = row.ID;

      //处理图片
      const imgUrl = row.imgurl || '';
      this.formData.txtImgUrl = imgUrl;
      // 设置显示的图片
      if (imgUrl) {
        this.sortImg = this.$setImgUrl(imgUrl);
      } else {
        this.sortImg = '';  // 清空图片显示
      }
  
      // 可选：清空其他可能残留的数据
      // this.formData.linkurl = '';
      // this.formData.UrlType = '';
      // this.formData.AndroidLinkUrl = '';
    },
    // 上传图片
    uploadSortImg(file) {
      if (file.length) {
        const formData = new FormData();
        formData.append("file", file[0]);
        this.$uploadRequest({
          method: "post",
          url: "admin/ashx/UploadImg.ashx?type=UploadFile&fileType=Navigation",
          data: formData,
        })
          .then((res) => {
            if (res.flag == 0) {
              this.formData.txtImgUrl = res.message;
              this.sortImg = this.$setImgUrl(res.message);
              this.$message.success("图片上传成功");
            } else {
              this.$message.error(res.message);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    /**提交表单 */
    sureModify() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          let data = {
            type: "PC_AddImgTypeValue",
            id: this.formData.id,
            sort: this.formData.sort,
            imgurl: this.formData.txtImgUrl,
            linkurl: this.formData.linkurl,
            Name: this.formData.name,
            urltype: this.formData.UrlType,
            androidlinkurl: this.formData.AndroidLinkUrl,
          };
          let proc = "Pc_Log"; //存储过程名
          let type = "ReturnNumber";
          ///加载页面数据
          this.$requestSys({
            method: "post",
            url:
              "rechargeorder/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            dataType: "json",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: res.message,
                  type: "success",
                });
                this.getTableData();
                this.resetForm();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        }
      });
    },
    /**启用禁用 */
    changeStatus({ row }, status) {
      let data = {
        id: row.ID,
        type: "PC_UpdateImgTypeStatus",
        Status: status,
      };
      var proc = "Pc_Log"; //存储过程名
      var type = "ReturnNumber";
      ///加载页面数据
      this.$requestSys({
        method: "post",
        url:
          "configuration/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          if (res.flag == 0) {
            //更新本页面数据就可以了
            this.getTableData();
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**重置表单 */
    resetForm() {
      this.$refs["addForm"].resetFields();
      this.dialogVisible = false;
      this.formData = {
        name: "",
        sort: 1,
        id: "",
        txtImgUrl: "",
        linkurl: "",
        UrlType: "",
        AndroidLinkUrl: "",
      };
  this.sortImg = "";  // 清空图片显示
    },

    /**商品绑定 */
    /**查看分类商品，弹出一个dialog显示表单，将选择的商品存放在暂存区 */
    handleGoods({ row }) {
      this.$router.push({
        path: "floorGoods",
        query: {
          id: row.ID,
          title: row.TypeName,
        },
      });
    },
    /**图片绑定 */
    handleImg({ row }) {
      this.$router.push({
        path: "floorImgs",
        query: {
          id: row.ID,
          title: row.TypeName,
          navType:row.ImgType
        }
      })
    }
  },
};
</script>

<style scoped>
.floorSetting {
  width: 100%;
  height: 100%;
  background-color: #fff;
}
</style>
